//form validation and other validation logic

//Alphanumeric check

export const alphaNumeriCheck =(str)=>{
    return /^[a-zA-Z0-9\s]*$/.test(str)
}
export const allowedSpecialCharacterCheck =(str)=>{
    return /^[ A-Za-z0-9_@./#&+,:()-]*$/.test(str)
}
export const decimalCheck =(str)=>{
    return /^\d+$/.test(str)
}
export const specialCharacterCheck =(str)=>{
    return /^[_@./#&+,:()-]+$/.test(str)
}

export const fillStringIfTooShort = (str, targetLength, fillValue) => {
    if (str.length < targetLength) {
      return str.padStart(targetLength, fillValue); // Use padStart to fill with 'fillValue' at the start
    }
    return str; 
  }